import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalDate } from '../../../config/utils/dateHelpers';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { RECEIVING_NOTE_PURPOSE } from '../../../interfaces/myData.interface';
import { isQuantityReceiptForm } from '../../../services/utils/myDataUtils';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewExtraInfo = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getShipToValue = useCallback(() => {
    return `${doc?.shipTo} ${doc?.shipToCity || ''} ${doc?.shipToPostalCode || ''}`;
  }, [doc?.shipTo, doc?.shipToCity, doc?.shipToPostalCode]);

  const getDocPurpose2 = useCallback(() => {
    if (doc?.docPurpose2?.name) {
      return ` - ${t(`DOC_PURPOSES.${doc?.docPurpose2?.name}`)}`;
    }
  }, [doc?.docPurpose2?.name, t]);

  return (
    <div className="flex-start-center-column-nowrap">
      <div className="flex-center-center-row-wrap">
        <div className="boldText1">{t('PDF.DOC_DATA')}</div>
      </div>
      <div className="flex-start-center-column-nowrap simpleBorder">
        <div className="containerExtraInfo">
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.DOC_PURPOSE')}:</div>
            <div className="normalText0">
              {t(`DOC_PURPOSES.${doc?.docPurpose?.name}`)}
              {getDocPurpose2()}
            </div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.PAYMENT_TYPE')}:</div>
            <div className="normalText0">{t(`PAYMENT_TYPES.${doc?.paymentType?.name}`)}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.DELIVERY_TYPE')}:</div>
            <div className="normalText0">{doc?.shipping}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.DELIVERY_TIME')}:</div>
            <div className="normalText0">{doc?.shipDate ? getLocalDate(doc?.shipDate) : ' - '}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.DELIVERY_PLACE')}:</div>
            <div className="normalText0">{doc?.shipFrom}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 text-no-wrap padding-r-6">{t('PDF.DELIVERY_RECEIVE')}:</div>
            <div className="normalText0 truncate-2lines">{getShipToValue()}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText10 padding-r-6">{t('PDF.VAT_REGIME')}:</div>
            <div className="normalText0">{t(`VAT_REGIME.${doc?.vatRegime?.name}`)}</div>
          </div>
          {isQuantityReceiptForm(doc.documentType?.aadeCode) && doc.receivingNotePurpose != null ? (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText10 padding-r-6 text-no-wrap">{t('PDF.RECEIVING_NOTE_PURPOSE')}:</div>
              <div className="normalText0">
                {doc.receivingNotePurpose === RECEIVING_NOTE_PURPOSE.OTHER
                  ? doc.otherReceivingNotePurposeTitle
                  : t(`SALE.RECEIVING_NOTE_PURPOSE_${doc.receivingNotePurpose}`)}
              </div>
            </div>
          ) : (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText10 padding-r-6 text-no-wrap">{t('PDF.VAT_EXCEPTION_CAT')}:</div>
              <div className="normalText0">
                {doc?.vatExceptionCategoryId ? t(`VAT_EXCEPTION_CAT.${doc?.vatExceptionCategory?.name}`) : ''}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
